import {
    useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import useLabel from 'app/hooks/useLabel'
import useTableStyles from 'app/tss/table.styles'

import requestConfig from 'app/requests/LongTermLease/LongTermLease.requests'
import {
    DedicatedContainerType,
} from '../../longTermLease.types'
import getColumns from './dedicatedContainersChange.columns'

const DedicatedContainersChange = ({
    longTermLeaseId,
}: {
    longTermLeaseId: number,
}) => {
    const l = useLabel()

    const {
        classes: tableClasses,
    } = useTableStyles()

    const loadConfig = useMemo(() => {
        const urlConfig = requestConfig.rejectedContainerChange(longTermLeaseId)

        return {
            ...urlConfig,
            customUrl: urlConfig.url,
            name: 'DedicatedContainersChange',
        }
    }, [longTermLeaseId])

    const load: (params: any) => Promise<{
        items: DedicatedContainerType[],
        matches: number,
    }> = useLoadDtoForSkyNetTable(loadConfig)

    const columns = getColumns(l)

    return (
        <RichTable
            configName="DedicatedContainersChangeTable"
            name="DedicatedContainersChange"
            columns={columns}
            load={load}
            className={tableClasses.tableContent}
            classNames={{
                contentWrapper: tableClasses.tableContentWrapper,
            }}
        />
    )
}

export default DedicatedContainersChange
